module.exports = __webpack_public_path__ + "img/house5.6337d0f5.png";